import { Component, Injectable } from '@angular/core';
import { MsgMobilePreview } from '../../msg-interface/msg-mobile-preview';

@Component({
  selector: 'icc-tiktok-mobile-preview',
  templateUrl: './tiktok-mobile-preview.component.html',
  styles: [],
})
export class TiktokMobilePreviewComponent implements MsgMobilePreview {
  constructor() {}
  SCENE = 'icc-msg-mobile-preview';
  type: number;
  setData(): void {
    // throw new Error('Method not implemented.');
  }
  clear(): void {
    // throw new Error('Method not implemented.');
  }
}
